import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './parts.css'

/**
 * The main content region of a composed [Modal](/components/modal/). This is the
 * scrolling zone (when the modal is `scrollable`) between the fixed header and
 * footer, and carries the modal's body padding.
 *
 * It occupies the modal's default slot, so place it as a direct child of
 * `nord-modal` (no `slot` attribute).
 *
 * @status draft
 * @category overlay
 * @lightDom true
 *
 * @slot - The modal body content.
 */
@customElement('nord-modal-body')
export default class ModalBody extends DraftComponentMixin(LitElement) {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style, 'nord-modal-parts')
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-modal-body': ModalBody
  }
}
